import { connect } from 'react-redux'

import { prevHistory, setPoptartHistory } from 'store/MemberCommunication'
import { RequestFlows as BaseRequestFlows } from './RequestFlows'

const mapStateToProps = ({ Expense, Member, MemberCommunication }) => ({
  requestType: MemberCommunication.requestType?.entity,
  history: MemberCommunication.requestFlows?.history,
  members: Object.values(Member.members?.entities || {}),
  // retrieve the workingExpense from the store
  workingExpense: Expense.workingExpense.entity || {},
  workingExpenseUuid: Expense.workingExpense.entity?.uuid || '',
})

const mapDispatchToProps = { setPoptartHistory, prevHistory }

// Merge function to ensure props like setOpen and setShouldAlert are passed through
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
})

export const RequestFlows = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(BaseRequestFlows)
